/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Level_PhoneInputs */

const en_us2_body_assessment_cue_level_phone = /** @type {(inputs: Body_Assessment_Cue_Level_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The phone is no longer level.`)
};

const pt_br2_body_assessment_cue_level_phone = /** @type {(inputs: Body_Assessment_Cue_Level_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O celular saiu do nível.`)
};

const es_419_body_assessment_cue_level_phone = /** @type {(inputs: Body_Assessment_Cue_Level_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El teléfono ya no está nivelado.`)
};

const pt_pt2_body_assessment_cue_level_phone = /** @type {(inputs: Body_Assessment_Cue_Level_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O telemóvel saiu do nível.`)
};

const fr_fr2_body_assessment_cue_level_phone = /** @type {(inputs: Body_Assessment_Cue_Level_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le téléphone n'est plus de niveau.`)
};

const de_de2_body_assessment_cue_level_phone = /** @type {(inputs: Body_Assessment_Cue_Level_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Handy ist nicht mehr gerade.`)
};

const it_it2_body_assessment_cue_level_phone = /** @type {(inputs: Body_Assessment_Cue_Level_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il telefono non è più in bolla.`)
};

/**
* | output |
* | --- |
* | "The phone is no longer level." |
*
* @param {Body_Assessment_Cue_Level_PhoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_level_phone = /** @type {((inputs?: Body_Assessment_Cue_Level_PhoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Level_PhoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_level_phone(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_level_phone(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_level_phone(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_level_phone(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_level_phone(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_level_phone(inputs)
	return en_us2_body_assessment_cue_level_phone(inputs)
});
export { body_assessment_cue_level_phone as "body-assessment.cue.level_phone" }